import { EnglishArabicDTO } from "bbsf-controls"
export class WFCreationModel
{
      Id:number
      IDEncrypted:string
      SysName :string
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      Description :EnglishArabicDTO=new EnglishArabicDTO();
      CurrentVersionID :number
      WorkflowVersionIDEncrypted:string
      IsActive:boolean
      IsPublished:boolean
}
     